(function() {

	angular
		.module('ngmvac')
		.filter('cambioImagen', CambioImagen);

	function CambioImagen() {
		
				return function(arr, path,btn)
 {

				var posicion ="";
                var imagen ="";
                var num=arr.length-1;

				for(var i=0; i<arr.length; i++)
				{
					if(arr[i]==path)
					{
                       posicion=i;  
                       break;
					}
				}

			

			if(btn=='ant')
			{
				posicion=posicion-1;
				if(posicion<0)
				{
                   posicion=num;
				}
				 imagen=arr[posicion];
                
			}
           else if(btn=='sig')
			{

				posicion=posicion+1;
				if(posicion>num)
				{
                   posicion='0';
				}
               imagen=arr[posicion];
			}
			
			return imagen;
				
	
}

}

})();